import { jt, t } from "ttag";

import { TrustpilotStars } from "@/assets/onboarding/trustpilot-stars";
import { Heading } from "@/shared/ui";

export const TrustpilotReviews = () => {
  const forThemselves = (
    <span key="for-themselves" className="text-secondary-500">
      {t`for themselves!`}
    </span>
  );

  const testimonials = [
    {
      title: t`Very good experience so far`,
      description: t`Very good experience so far. what stood out to me was the follow up and support, every time I needed something someone was there for me and honestly thats rare today. Big thanks to Ilana for all the help.`,
      author: "Daniel Wesley",
      date: t`March 9, 2026`,
    },
    {
      title: t`Great support fast delivery`,
      description: t`so far I'm happy with levelsrx, Anna helped me a ton picking the right plan and she was super patient with me. I got my stuff today and everything was perfect. Excited to start and I'll update later with progress.`,
      author: "Brian Stewart",
      date: t`March 3, 2026`,
    },
    {
      title: t`Switched to this company after hearing good things`,
      description: t`Switched to this company after hearing good things, and I'm glad I did. Got my product already and I'm really happy with it. Linda was supper helpful too, so far so good!`,
      author: "Anna Bowens",
      date: t`February 6, 2026`,
    },
  ];

  return (
    <section className="flex flex-col items-center gap-6">
      <Heading level={3} size="large" color="primary" align="center">
        {jt`The results speak ${forThemselves}`}
      </Heading>

      <div className="flex items-center gap-4">
        <TrustpilotStars full={false} className="w-32" />

        <p className="text-sm font-medium text-primary-900">
          {t`Excellent`} 4.7
        </p>
      </div>

      {testimonials.map((testimonial) => (
        <TestimonialCard key={testimonial.title} {...testimonial} />
      ))}
    </section>
  );
};

interface Testimonial {
  title: string;
  description: string;
  author: string;
  date: string;
}

const TestimonialCard = ({ title, description, author, date }: Testimonial) => {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-primary-200 bg-primary-50 p-5">
      <div className="flex justify-between gap-2">
        <p className="text-lg font-bold text-primary-800">{title}</p>

        <TrustpilotStars className="w-32" />
      </div>

      <p className="text-primary-950">{description}</p>

      <div className="flex justify-between gap-2 text-sm">
        <p className="font-medium text-primary-950">{author}</p>

        <p className="text-neutral-600">{date}</p>
      </div>
    </div>
  );
};
